/* eslint-disable */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isMatch } from 'date-fns';
import { FiCalendar } from 'react-icons/fi';
import { RiLock2Fill, RiBankCardLine, RiEmotionHappyLine, RiArrowDownSLine } from 'react-icons/ri';
import { ToastContainer } from 'react-toastify';
import { useTranslation } from '../../i18n';
import Service from '../../services/Service';
import * as FormActions from '../../store/form/actions';
import Validations from '../../util/Validations';
import FieldText from '../FieldText';
import Loading from '../Loading';
import { getOnboardingProgress, OnboardingBackNavigation, OnboardingFrame, OnboardingHeader, OnboardingPrimaryButton, OnboardingProgress, OnboardingSecurityFooter, OnboardingShell, } from '../onboarding-visual';
import { ReviewGroup, ReviewAttachments, BeforeButton, DateField, ErrorMessage, FieldLink, Fields, FormActionArea, FormContent, FormScrollArea, ScrollHint, PrivacyNotice, StepIndicator, SubTitle, Title, } from './styles';
var formCopyByLanguage = {
    en: {
        subtitle: 'Fill in your information as it appears on your document.',
        title: 'Nice to meet you',
    },
    'pt-BR': {
        subtitle: 'Preencha seus dados como aparecem no seu documento.',
        title: 'Prazer em conhecer você',
    },
};
var toInteger = function (value) {
    var parsedValue = typeof value === 'number' ? value : typeof value === 'string' && value.trim() ? Number(value) : NaN;
    if (!isFinite(parsedValue) || Math.floor(parsedValue) !== parsedValue)
        return undefined;
    return parsedValue;
};
var toPositiveInteger = function (value) {
    var parsedValue = toInteger(value);
    return parsedValue && parsedValue > 0 ? parsedValue : undefined;
};
var getStepFromIndex = function (value) {
    var stepIndex = toInteger(value);
    return stepIndex !== undefined && stepIndex >= 0 ? stepIndex + 1 : undefined;
};
var isMissingCountSteps = function (value) {
    return value === undefined || value === null || (typeof value === 'string' && !value.trim());
};
/**
 * The form list is only a visual total fallback when it describes the complete
 * business sequence. Partial step responses must not create a misleading total.
 */
var getCompleteStepsCount = function (steps) {
    if (!Array.isArray(steps) || !steps.length)
        return undefined;
    var stepNumbers = [];
    for (var index = 0; index < steps.length; index += 1) {
        var item = steps[index];
        if (!item || typeof item !== 'object')
            return undefined;
        var businessStep = toPositiveInteger(item.step);
        if (!businessStep)
            return undefined;
        stepNumbers.push(businessStep);
    }
    return stepNumbers
        .slice()
        .sort(function (left, right) { return left - right; })
        .every(function (businessStep, index) { return businessStep === index + 1; })
        ? stepNumbers.length
        : undefined;
};
var getFormProgress = function (form, formStep, stepIndex) {
    var configuredProgress = getOnboardingProgress(form, formStep);
    if (configuredProgress)
        return configuredProgress;
    var progressForm = form;
    var progressStep = formStep;
    var reportedTotalSteps = toPositiveInteger(progressForm.countSteps);
    var totalSteps = reportedTotalSteps ||
        (isMissingCountSteps(progressForm.countSteps) ? getCompleteStepsCount(progressForm.steps) : undefined);
    if (!totalSteps)
        return null;
    var reportedCurrentStep = toPositiveInteger(progressStep.step);
    var currentStep = reportedCurrentStep && reportedCurrentStep <= totalSteps ? reportedCurrentStep : getStepFromIndex(stepIndex);
    if (!currentStep || currentStep > totalSteps)
        return null;
    return getOnboardingProgress({ countSteps: totalSteps }, { step: currentStep });
};
var getFormCopy = function (language) {
    return language && language.toLowerCase().indexOf('pt') === 0 ? formCopyByLanguage['pt-BR'] : formCopyByLanguage.en;
};
var StepForm = function (_a) {
    var step = _a.step, onPressConfirm = _a.onPressConfirm, isSubmitLoading = _a.loading;
    var theme = useSelector(function (state) { return state.theme; }).theme;
    var _b = useSelector(function (state) { return state.form; }), form = _b.form, formInfo = _b.formInfo, progressForm = _b.progressForm, documentDataReview = _b.documentDataReview;
    var _c = useTranslation(), i18n = _c.i18n, t = _c.t;
    var dispatch = useDispatch();
    var _d = React.useState(false), loading = _d[0], setLoading = _d[1];
    var _e = React.useState(false), enableButton = _e[0], setEnableButton = _e[1];
    // const [currentStepForm, setCurrentStepForm] = React.useState<FormField[] | []>([]);
    var _f = React.useState([]), calledServiceFields = _f[0], setCalledServiceFields = _f[1];
    var _g = React.useState({}), touchedFields = _g[0], setTouchedFields = _g[1];
    var _h = React.useState({}), errorMessages = _h[0], setErrorMessages = _h[1];
    var currentStep = form.steps[step];
    var progress = getFormProgress(progressForm || form, currentStep, step);
    var documentReview = (documentDataReview === null || documentDataReview === void 0 ? void 0 : documentDataReview.targetStep) === currentStep.step ? documentDataReview : undefined;
    var formCopy = getFormCopy(i18n.resolvedLanguage || i18n.language);
    var scrollAreaRef = React.useRef(null);
    var scrollContentRef = React.useRef(null);
    var _j = React.useState(false), hasMoreFields = _j[0], setHasMoreFields = _j[1];
    React.useEffect(function () {
        var area = scrollAreaRef.current;
        var content = scrollContentRef.current;
        if (!area || !content)
            return;
        var update = function () { return setHasMoreFields(area.scrollHeight - area.clientHeight - area.scrollTop > 8); };
        update();
        area.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        var observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(update) : null;
        observer === null || observer === void 0 ? void 0 : observer.observe(area);
        observer === null || observer === void 0 ? void 0 : observer.observe(content);
        return function () {
            area.removeEventListener('scroll', update);
            window.removeEventListener('resize', update);
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, [step]);
    var callFieldService = function (field) {
        var params = {
            tokenOnboarding: (formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding) || '',
            step: form.steps[step].step,
        };
        if (field) {
            params.field = field.field;
            params.value = field.value;
        }
        Service.serviceField(params).then(function (response) {
            if (response.find(function (f) { return f.nextStep; })) {
                onPressConfirm();
            }
            else {
                var newForm = __assign({}, form);
                newForm.steps[step].fields = newForm.steps[step].fields.map(function (field) {
                    var index = response.findIndex(function (f) { return f.field === field.field; });
                    if (index === -1) {
                        return field;
                    }
                    else {
                        Object.keys(response[index]).forEach(function (key) { return !response[index][key] && delete response[index][key]; });
                        return __assign(__assign({}, field), response[index]);
                    }
                });
                dispatch(FormActions.setForm(newForm));
            }
        });
    };
    var onFieldButtonPress = function (field) {
        callFieldService(field);
    };
    React.useEffect(function () {
        var isValid = true;
        var errors = {};
        form.steps[step].fields.forEach(function (field) {
            var _a;
            var fieldIsValid = validateField(field);
            if (field.nextStep) {
                isValid = false;
            }
            if (!fieldIsValid) {
                isValid = false;
                if (touchedFields[field.field]) {
                    errors[field.field] = getFieldErrorMessage(field);
                }
            }
            if (field.callService && ((_a = field.value) === null || _a === void 0 ? void 0 : _a.length) === field.minSize) {
                // checar se ja foi chamado com o msm valor
                var index = calledServiceFields.findIndex(function (f) { return f.field === field.field; });
                var newArray = __spreadArray([], calledServiceFields, true);
                if (index >= 0) {
                    if (calledServiceFields[index].value !== field.value) {
                        callFieldService(field);
                        newArray[index] = __assign({}, field);
                        setCalledServiceFields(newArray);
                    }
                }
                else {
                    callFieldService(field);
                    newArray.push(__assign({}, field));
                    setCalledServiceFields(newArray);
                }
            }
        });
        setErrorMessages(errors);
        setEnableButton(isValid);
    }, [form, touchedFields]);
    function validateField(field) {
        var _a;
        if (!field.required) {
            return true;
        }
        if (field.required && !field.value) {
            return false;
        }
        if (!field.value) {
            return false;
        }
        switch (field.field) {
            case 'cpf':
                return Validations.validateCPF(field.value);
            case 'cnpj':
                return Validations.validateCNPJ(field.value);
            case 'rg_number':
                return Validations.validateRG(field.value);
            case 'zipcode':
                return Validations.validateCEP(field.value);
            case 'account_number':
                return Validations.validateAccountNumber(field.value);
            case 'bank_agency':
                return Validations.validateBankAgency(field.value);
            case 'email':
                return Validations.validateEmail(field.value);
            case 'phone':
                return Validations.validatePhone(field.value);
            case 'password':
                return Validations.validatePassword(field.value);
            case 'confirmPassword':
                var password = (_a = form.steps[step].fields.find(function (f) { return f.field === 'password'; })) === null || _a === void 0 ? void 0 : _a.value;
                return field.value === password;
            default:
                if (field.type === 'DATE') {
                    var formattedDate = new Date(field.value).toLocaleDateString('pt-BR');
                    return isMatch(formattedDate, field.maskRegex);
                }
                return true;
        }
    }
    function getFieldErrorMessage(field) {
        if (field.required && !field.value) {
            return t('form.required');
        }
        switch (field.field) {
            case 'cpf':
                return t('form.invalidCpf');
            case 'cnpj':
                return t('form.invalidCnpj');
            case 'rg_number':
                return t('form.invalidRg');
            case 'zipcode':
                return t('form.invalidZipcode');
            case 'account_number':
                return t('form.invalidAccount');
            case 'bank_agency':
                return t('form.invalidBankAgency');
            case 'email':
                return t('form.invalidEmail');
            case 'phone':
                return t('form.invalidPhone');
            case 'password':
                return t('form.invalidPassword');
            case 'confirmPassword':
                return t('form.passwordsDoNotMatch');
            default:
                return '';
        }
    }
    React.useEffect(function () {
        if (step) {
            setLoading(false);
            setEnableButton(false);
        }
    }, [step]);
    React.useEffect(function () {
        if (form.steps[step].callService) {
            callFieldService();
        }
    }, []);
    return (React.createElement(OnboardingShell, { "data-sentry-mask": "" },
        React.createElement(OnboardingFrame, null,
            React.createElement(ToastContainer, null),
            React.createElement(OnboardingHeader, { logo: theme.logo, hideLogo: theme.logoPosition === 'none' }),
            React.createElement(OnboardingProgress, { currentStep: progress === null || progress === void 0 ? void 0 : progress.currentStep, showLabel: false, totalSteps: progress === null || progress === void 0 ? void 0 : progress.totalSteps }),
            React.createElement(FormContent, null,
                React.createElement(FormScrollArea, { ref: scrollAreaRef },
                    React.createElement("div", { ref: scrollContentRef },
                        progress && (React.createElement(StepIndicator, null, t('termsConsent.progress', { current: progress.currentStep, total: progress.totalSteps }))),
                        React.createElement(Title, null, documentReview ? t('image.dataReviewTitle') : formCopy.title),
                        React.createElement(SubTitle, null, documentReview ? t('image.dataReviewSubtitle') : formCopy.subtitle),
                        React.createElement(ReviewGroup, { as: documentReview ? 'details' : 'div', open: documentReview ? true : undefined },
                            documentReview && React.createElement("summary", null,
                                React.createElement("span", null,
                                    React.createElement("strong", null, t('image.dataReviewFields')),
                                    React.createElement("small", null, t('image.dataReviewFieldsHint'))),
                                React.createElement(RiArrowDownSLine, { "aria-hidden": "true" })),
                            React.createElement(Fields, null,
                                currentStep.fields.map(function (field, index) {
                                    if (field.visible) {
                                        if (field.type === 'LINK') {
                                            return (React.createElement(FieldLink, { key: index, onClick: function () { return onFieldButtonPress(field); } }, field.label));
                                        }
                                        var shouldShowDateIcon = field.type === 'DATE' &&
                                            Boolean(field.maskRegex && (field.maskRegex.includes('dd') || field.maskRegex.includes('YY')));
                                        var fieldInput = (React.createElement(FieldText, { field: field, onBlur: function () {
                                                var _a;
                                                return setTouchedFields(__assign(__assign({}, touchedFields), (_a = {}, _a[field.field] = true, _a)));
                                            }, onChangeText: function (text) {
                                                if (field.enabled === false)
                                                    return;
                                                var newForm = __assign({}, form);
                                                newForm.steps[step].fields[index].value = text;
                                                dispatch(FormActions.setForm(newForm));
                                            } }));
                                        return (React.createElement("div", { key: index },
                                            shouldShowDateIcon ? (React.createElement(DateField, null,
                                                fieldInput,
                                                React.createElement(FiCalendar, { "aria-hidden": "true" }))) : (fieldInput),
                                            errorMessages[field.field] && (React.createElement(ErrorMessage, { role: "alert" }, errorMessages[field.field]))));
                                    }
                                }),
                                currentStep.formText && (React.createElement(PrivacyNotice, null,
                                    React.createElement(RiLock2Fill, { "aria-hidden": "true" }),
                                    React.createElement(BeforeButton, null, currentStep.formText))))),
                        documentReview && React.createElement(ReviewAttachments, { "data-sentry-mask": "" },
                            documentReview.documents.map(function (document, index) { return React.createElement("details", { key: index },
                                React.createElement("summary", null,
                                    React.createElement(RiBankCardLine, { "aria-hidden": "true" }),
                                    React.createElement("span", null,
                                        React.createElement("strong", null, document.label),
                                        React.createElement("small", null, t('image.previewAttached'))),
                                    React.createElement(RiArrowDownSLine, { "aria-hidden": "true" })),
                                document.value.startsWith('data:image/') ? React.createElement("img", { src: document.value, alt: document.label }) : React.createElement("a", { href: document.value, target: "_blank", rel: "noreferrer" }, t('image.dataReviewOpenDocument'))); }),
                            form.steps.slice(0, step).some(function (item) { return item.type === 'SELFIE' || item.type.startsWith('LIVENESS'); }) && React.createElement("div", { className: "review-selfie" },
                                React.createElement(RiEmotionHappyLine, { "aria-hidden": "true" }),
                                React.createElement("span", null,
                                    React.createElement("strong", null, t('image.dataReviewSelfie')),
                                    React.createElement("small", null, t('image.reviewDone'))))))),
                React.createElement(FormActionArea, null,
                    hasMoreFields && React.createElement(ScrollHint, { type: "button", onClick: function () {
                            var area = scrollAreaRef.current;
                            area === null || area === void 0 ? void 0 : area.scrollBy({ top: area.clientHeight * 0.65, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
                        } },
                        React.createElement("span", null, t('form.scrollForMore')),
                        React.createElement(RiArrowDownSLine, { "aria-hidden": "true" })),
                    React.createElement(OnboardingPrimaryButton, { disabled: !enableButton || loading || isSubmitLoading, onClick: onPressConfirm }, documentReview ? t('image.dataReviewConfirm') : t('common.continue')),
                    React.createElement(OnboardingBackNavigation, { label: t('common.back'), show: currentStep.goBack }),
                    React.createElement(OnboardingSecurityFooter, { text: t('common.secureEnvironment') }))),
            loading && React.createElement(Loading, null))));
};
export default StepForm;
